import { User } from '../auth/interfaces/user';
import { appendQueryParams } from '../shared/utils/url';

export function appendTrackingParams(
  path: string,
  section: string,
  user: User,
  properties?: object
) {
  const params = new URLSearchParams((properties as { [key: string]: string }) || {});
  params.set('ui_section', section);
  params.set('app_user', user.email);
  return appendQueryParams(path, params.toString());
}
